export const CHECKOUT_URL = 'https://predic-en.impultienda.ar/checkout/';

export const images = {
  mockup: 'https://cdn.magicpatterns.com/uploads/vYzeWjAPi12xVxVdi6HHvN/MOCKUP_PREDIC-EN.png',
  author: 'https://cdn.magicpatterns.com/uploads/ouSuGL12rRaL6GpLJrf9bh/Dr._Sarah_Collins_-_DENTAL.png',
};

export const heroChecks = [
  'Instant Digital Access',
  'One-Time Payment',
  'Lifetime Access to Purchased Materials',
  '6 Clinical Volumes + 5 Exclusive Bonuses',
  '7-Day Money-Back Guarantee*',
];

export const offerChecks = [
  'All 6 Clinical Volumes',
  'All 5 Exclusive Bonuses',
  'Digital Reference Materials',
  'Lifetime Access to Purchased Files',
  'Instant Download After Purchase*',
  '7-Day Money-Back Guarantee*',
];

export const finalChecks = [
  '6 Specialized Clinical Volumes',
  '5 Exclusive Clinical Bonuses',
  'Visual Planning References',
  'Movement Risk Assessment Tools',
  'Digital Setup Review Checklists',
  'One-Time Payment',
  'Lifetime Access to Purchased Materials',
  '7-Day Money-Back Guarantee*',
];

export const withoutRoadmap = [
  'You rely heavily on what the digital simulation displays.',
  'Difficult movements may go unnoticed during planning.',
  'You struggle to compare biomechanical alternatives.',
  'Attachment selection feels inconsistent.',
  'Treatment sequencing becomes harder to evaluate.',
  'Tracking problems catch you by surprise.',
  'You spend valuable time searching for clinical guidance.',
];

export const withRoadmap = [
  'Identify movement-specific risk factors before treatment.',
  'Recognize common biomechanical limitations.',
  'Review digital setups using structured clinical criteria.',
  'Evaluate attachment strategies more systematically.',
  'Understand movement sequencing considerations.',
  'Recognize early signs of tracking discrepancies.',
  'Access visual decision pathways when you need them.',
];

export const offerItems = [
  { name: 'DENTAL PREDICTABILITY ROADMAP™ — Complete 6-Volume Collection', value: '$97', bonus: false, highlight: true },
  { name: 'Volume 1: Dental Predictability Roadmap™', value: 'Included', bonus: false, highlight: false },
  { name: 'Volume 2: Aligner Treatment Planning Blueprint™', value: 'Included', bonus: false, highlight: false },
  { name: 'Volume 3: Tooth Movement Predictability Atlas™', value: 'Included', bonus: false, highlight: false },
  { name: 'Volume 4: Biomechanical Control Blueprint™', value: 'Included', bonus: false, highlight: false },
  { name: 'Volume 5: Clinical Decision Pathways™', value: 'Included', bonus: false, highlight: false },
  { name: 'Volume 6: Aligner Success Roadmap™', value: 'Included', bonus: false, highlight: false },
  { name: 'Predictability Risk Matrix™', value: '$37', bonus: true, highlight: false },
  { name: 'Attachment Selection Blueprint™', value: '$47', bonus: true, highlight: false },
  { name: 'Digital Setup Audit Checklist™', value: '$37', bonus: true, highlight: false },
  { name: 'Tracking Troubleshooting Roadmap™', value: '$47', bonus: true, highlight: false },
  { name: 'Clinical Case Planning Workbook™', value: '$37', bonus: true, highlight: false },
];

export const scarcity = {
  total: 100,
  remaining: 7,
};
